import React from 'react';
import { Text } from 'rebass';
import styled from 'styled-components';

// Styled span for the highlight
const Highlight = styled.span`
  background-color: #fff5d6;
`;

// Highlighting component
export const HighlightedText = ({
  text,
  match,
  fontSize = '14px'
}: {
  text: string;
  match: string;
  fontSize?: string;
}) => {
  if (!match) return <Text>{text}</Text>;

  const regex = new RegExp(`(${match})`, 'i');
  const parts = text.split(regex);

  return (
    <span style={{ fontSize }}>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <Highlight key={index}>{part}</Highlight>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  );
};